// @ai-generated 2026-07-21T03:45:01+00:00 by philipp.kammerer@synqony.com using claude-fable-5
import { useMessagesRepository } from '@Hooks/useRepository';
import { NotificationSettingsRepository } from '@Repositories/Messages';
import { unwrapOr } from '@synqo/frontend-component-library';
import { useQuery } from '@tanstack/react-query';

export function useNotificationSettingsQuery() {
    const settings = useMessagesRepository(NotificationSettingsRepository);

    const query = useQuery({
        queryKey: ['notificationSettings'],
        queryFn: async () => {
            const result = await settings.query();
            return unwrapOr(result, []);
        },
        refetchOnWindowFocus: false,
    });

    return {
        settings: query.data ?? [],
        isLoading: query.isLoading,
    };
}
